module.exports = __webpack_public_path__ + "img/features2.2e176d32.png";